import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import ProcessPage from "./pages/ProcessPage";
import ServicePage from "./pages/ServicePage";
import SecurityAuditPage from "./pages/SecurityAuditPage";
import LandingPage from "./pages/LandingPage";
import NotFoundPage from "./pages/NotFoundPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import BlogPostPage from "./pages/BlogPostPage";
import {
  mobileAppService,
  iosMobileService,
  androidMobileService,
  hybridMobileService,
  lowCodeMobileService,
  webAppService,
  customSoftwareService,
  ecommerceService,
  aiMlService,
} from "./data/services";
import { landingPages } from "./data/landingPages";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/mobile-app-development" element={<ServicePage service={mobileAppService} />} />
          <Route path="/services/mobile-app-development/ios" element={<ServicePage service={iosMobileService} />} />
          <Route path="/services/mobile-app-development/android" element={<ServicePage service={androidMobileService} />} />
          <Route path="/services/mobile-app-development/hybrid-cross-platform" element={<ServicePage service={hybridMobileService} />} />
          <Route path="/services/mobile-app-development/low-code-rmad" element={<ServicePage service={lowCodeMobileService} />} />
          <Route path="/services/web-app-development" element={<ServicePage service={webAppService} />} />
          <Route path="/services/custom-software" element={<ServicePage service={customSoftwareService} />} />
          <Route path="/services/ecommerce" element={<ServicePage service={ecommerceService} />} />
          <Route path="/services/ai-ml" element={<ServicePage service={aiMlService} />} />
          <Route path="/services/security-audits" element={<SecurityAuditPage />} />
          {landingPages.map((page) => (
            <Route
              key={page.path}
              path={page.path}
              element={<LandingPage page={page} />}
            />
          ))}
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
